import styled from 'styled-components';

/**
 * Checkmark wrapper shown next to the active sort option in dropdown.
 * Used by HelpDeskList and HelpDeskSidePanel.
 */
const SortCheck = styled.span`
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
  svg {
    width: 20px;
    height: 20px;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export default SortCheck;
